import { FC } from "react";
import { MDBCard, MDBCol, MDBRow } from "mdb-react-ui-kit";
import TagManager from "react-gtm-module";
import styles from "../../styles/contacts/Contacts.module.scss";
import contactsSvg from "../../utils/svg-icon/contacts";
import { ContactsInfo, TypeContact } from "../../models/contact";

interface RowContent {
    firstIcon: string;
    text: string;
    textToCopy?: string;
    valueToUse?: string;
    typeContact?: TypeContact;
    isCalendly?: boolean; // Identifica se è un link Calendly
    isEmail?: boolean; // Identifica se è un'email
}

const ContactCard: FC<{
    contactInfo: ContactsInfo;
}> = ({ contactInfo }) => {
    const {
        EmailLine,
        Phone,
        // MessengerLine,
        WhatsappLine,
        CalendarLine,
        // TelegramLine,
    } = contactsSvg;
    // textToCopy is only the part of text to copy to clipboard
    const rowContents: RowContent[] = [
        {
            firstIcon: Phone,
            text: contactInfo.phoneTitle || `Call us at ${contactInfo.number}`,
            textToCopy: `${contactInfo.number}`,
        },
        {
            firstIcon: EmailLine,
            text: contactInfo.emailTitle || contactInfo.email,
            textToCopy: `${contactInfo.email}`,
            isEmail: true,
        },
        // LIVE CHAT - DISABILITATA
        // {
        //     firstIcon: MessengerLine,
        //     text: "Live chat",
        //         },
        {
            firstIcon: WhatsappLine,
            text: contactInfo.contacts.whatsappTitle || "WhatsApp",
            valueToUse: `${contactInfo.contacts.whatsapp}`,
            textToCopy: `${contactInfo.contacts.whatsappPrefix ?? ""} ${
                contactInfo.contacts.whatsapp
            }`,
            typeContact: TypeContact.Whatsapp,
        },
        ...(contactInfo.id !== "book"
            ? [
                  {
                      firstIcon: CalendarLine,
                      text: contactInfo.contacts.calendlyTitle || "Book a call",
                      textToCopy: `${contactInfo.contacts.calendlyUri}`,
                      isCalendly: true,
                  },
              ]
            : []),
        // {
        //     firstIcon: TelegramLine,
        //     text: `${contactInfo.contacts.telegram}`,
        //     textToCopy: `${contactInfo.number}`,
        //     typeContact: TypeContact.Telegram,
        // },
    ];

    // eslint-disable-next-line sonarjs/cognitive-complexity
    const createRow = (content: RowContent) => {
        const handlePhoneClick = (phone: string) => {
            TagManager.dataLayer({
                dataLayer: {
                    event: "contacts_click",
                    contact_type: "phone",
                },
            });
            window.location.href = `tel:${phone}`;
        };

        const handleEmailClick = (email: string) => {
            TagManager.dataLayer({
                dataLayer: {
                    event: "contacts_click",
                    contact_type: "email",
                },
            });
            window.location.href = `mailto:${email}`;
        };

        const handleContactProviderClick = (
            type: TypeContact,
            text: string,
            textToCopy: string,
            valueToUse: string
        ) => {
            let provider = "";
            switch (type) {
                case TypeContact.Whatsapp:
                    provider = "https://wa.me/";
                    break;
                case TypeContact.Telegram:
                    provider = "https://t.me/";
                    break;
                default:
                    return;
            }
            if (type === TypeContact.Whatsapp) {
                TagManager.dataLayer({
                    dataLayer: {
                        event: "contacts_click",
                        contactType: "whatsapp",
                    },
                });
            }
            /*
                l'attributo valueToUse viene utilizzato solo quando il provider è Whatsapp in quanto per utilizzare 
                il suo url di redirect è necessario non aggiungere il prefisso.
                Il textToCopy (per permettere il copia all'utente) contiene il valore completo (prefisso + numero)
                Il valueToUse solo il numero (senza prefisso)
             */
            const href = `${provider}${
                type === TypeContact.Telegram ? text : valueToUse
            }`;
            window.open(href, "_blank");
        };

        const handleLinkClick = (url: string) => {
            if (url.includes("calendly.com")) {
                TagManager.dataLayer({
                    dataLayer: {
                        event: "calendly_click",
                        calendlyType: "calendly",
                    },
                });
            }
            window.open(url, "_blank");
        };

        const handleClick = () => {
            if (content?.isEmail && content?.textToCopy) {
                handleEmailClick(content.textToCopy);
            } else if (
                content?.textToCopy &&
                content?.textToCopy.match(/^\+?[0-9\s-]+$/) &&
                !content?.typeContact
            ) {
                handlePhoneClick(content.textToCopy);
            } else if (content?.typeContact) {
                handleContactProviderClick(
                    content.typeContact,
                    content.text,
                    content.textToCopy ?? "",
                    content.valueToUse ?? ""
                );
            } else if (content?.isCalendly) {
                handleLinkClick(content.textToCopy ?? "");
            } else if (
                content?.text.includes("http") ||
                content?.text.includes("https")
            ) {
                handleLinkClick(content.text);
            }
        };

        return (
            <MDBRow
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    cursor: "pointer",
                }}
                onClick={handleClick}
            >
                <MDBCol size={2} className={styles.leftSvg}>
                    <content.firstIcon />
                </MDBCol>
                <MDBCol size={10}>{content?.text}</MDBCol>
            </MDBRow>
        );
    };

    return (
        <MDBCol
            lg={5}
            md={5}
            xl={5}
            center
            className={`d-flex justify-content-center d-flex align-items-stretch ${styles.contactCardWrapper}`}
        >
            <MDBCard className={styles.infoCard}>
                <MDBRow className="justify-content-center w-100">
                    {rowContents.map(content => (
                        <MDBRow
                            className="justify-content-center align-items-center py-1 px-0 mb-2 p-0"
                            style={{ height: "46px" }}
                        >
                            <MDBCol size={12}>
                                <span className={styles.rowText}>
                                    {createRow(content)}
                                </span>
                            </MDBCol>
                        </MDBRow>
                    ))}
                </MDBRow>
            </MDBCard>
        </MDBCol>
    );
};

export default ContactCard;
